import { Seo } from '@/components/seo'
import { PageLayout } from '@/components/layout/page-layout'
import { Hero } from '@/components/home/hero'
import { ToolsSection } from '@/components/home/tools-section'
import { FeaturesSection } from '@/components/home/features-section'
import { WorkflowSection } from '@/components/home/workflow-section'
import { CtaSection } from '@/components/home/cta-section'
import { useI18n } from '@/lib/i18n'

export default function HomePage() {
  const { t } = useI18n()

  return (
    <PageLayout>
      <Seo
        title={t('seoHomeTitle')}
        description={t('seoHomeDesc')}
        keywords={t('seoHomeKw').split(',').map((item) => item.trim())}
      />
      <Hero />
      <ToolsSection />
      <FeaturesSection />
      <WorkflowSection />
      <CtaSection />
    </PageLayout>
  )
}